import { connect } from 'react-redux';
import { addTour, editTour, requestTours, requestTour, selectTour, tourFilterSet,requestTourManagers, changeTourPin } from '../modules/tour';

import Tours from '../components/Tours';

const mapDispatchToProps = {
  requestTours,
  requestTour,
  selectTour,
  addTour,
  editTour,
  tourFilterSet,
  requestTourManagers,
  changeTourPin
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.tours.isFetching,
  needFetch: state.tours.needFetch,
  hasError: state.tours.hasError,
  tours: state.tours.tours,
  id: ownProps.params.id,
  selectedTour: {
    tour: state.tours.selectedTour.tour,
    hasError: state.tours.selectedTour.hasError,
    isFetching: state.tours.selectedTour.isFetching,
    needFetch: state.tours.selectedTour.needFetch,
    activeTab: ownProps.params.key,
  },
  tourStateFilter: state.tours.tourStateFilter,

  isTourManager: state.auth.perms.includes('tour_management'),
  tourManagers: state.tours.tourManagers
});

export default connect(mapStateToProps, mapDispatchToProps)(Tours);



// WEBPACK FOOTER //
// src/routes/tours/containers/ToursContainers.js